<template>
  <span>{{ label }}<svg
      v-if="tooltip"
      v-tooltip="{ content: tooltip, trigger: 'hover touch click focus' }"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 21 21"
      class="tooltip-icon"
    >
        <path d="M10.261 9.06152H10.743C11.0078 9.06152 11.2219 9.32625 11.2219 9.54034V15.2957C11.2219 15.5604 11.0078 15.7745 10.743 15.7745H10.261C9.99632 15.7745 9.78223 15.5098 9.78223 15.2957V9.54034C9.78223 9.27561 9.99633 9.06152 10.261 9.06152Z" />
        <path d="M10.261 5.70801H10.743C11.0078 5.70801 11.2219 5.97273 11.2219 6.18683V7.14765C11.2219 7.41238 11.0078 7.62647 10.743 7.62647H10.261C9.99632 7.62647 9.78223 7.36174 9.78223 7.14765V6.18683C9.78223 5.9221 9.99633 5.70801 10.261 5.70801Z" />
        <path d="M10.5005 19.1279C12.7892 19.1279 14.9831 18.2198 16.6009 16.6008C18.2199 14.9829 19.128 12.7892 19.128 10.5004C19.128 8.21164 18.2199 6.01789 16.6009 4.40005C14.983 2.78111 12.7893 1.87302 10.5005 1.87302C8.21175 1.87302 6.018 2.78111 4.40016 4.40005C2.78122 6.01795 1.87313 8.21164 1.87313 10.5004C1.87313 12.7892 2.78122 14.983 4.40016 16.6008C6.01806 18.2198 8.21175 19.1279 10.5005 19.1279ZM10.5005 20.5664V20.5675C7.83113 20.5675 5.27037 19.5065 3.38253 17.6186C1.49464 15.7307 0.433594 13.1698 0.433594 10.5005C0.433594 7.83133 1.49461 5.27037 3.38253 3.38253C5.27043 1.49464 7.83132 0.433594 10.5005 0.433594C13.1698 0.433594 15.7307 1.49461 17.6186 3.38253C19.5064 5.27043 20.5675 7.83133 20.5675 10.5005C20.5675 13.1698 19.5065 15.7307 17.6186 17.6186C15.7307 19.5064 13.1698 20.5675 10.5005 20.5675V20.5664Z" />
    </svg>
  </span>
</template>

<script>

export default {
  props: {
    // context: {
    //   type: Object,
    //   required: true
    // },
    label: {
      type: String
    },
    tooltip: {
      type: String
    },
  },
  data () {
    return {
      
    }
  },
  watch: {

  },
  computed: {
    
  },
  methods: {
    
  },
}
</script>

<style scoped lang="scss">
.tooltip-icon {
    width: 1.25em;
    height: 1.25em;
    fill: #00A7FF;
    margin-left: 0.5rem;
    margin-right: 0.5rem;
    display: inline-block;
    vertical-align: middle;
}
</style>